<template>
  <v-row dense style="line-height: 36px;" class="align-center">
    <v-col class="d-lg-inline-flex align-center" v-if="items && items.length > 0">
      <v-checkbox v-for="(item, index) in checkboxesItems"
                  :key="item + '_' + index"
                  v-model="selectedItems"
                  :label="item"
                  :value="item"
                  class="mr-0 mr-sm-5 mt-1"
                  hide-details/>
    </v-col>
    <v-col v-else>Keine Daten verfügbar</v-col>

    <v-col cols="auto">
      <v-btn icon style="float: right;" @click="$emit('delete')">
        <v-icon>icon-delete</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'FinScreenerCheckboxesSelector',
  components: {},
  props: {
    label: {
      type: String
    },
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array
    },
  },
  data() {
    return {
      selectedItems: this.value.map(value => {
        return value['name']
      }),
      checkboxesItems: this.items.map(value => {
        return value['name']
      })
    }
  },
  watch: {
    // reacts on changes on checkboxes
    selectedItems(newVal) {
      const selected = []
      newVal.forEach(itemSelected => {
        const origItem = this.items.find(item => item.name === itemSelected)
        selected.push(origItem)
      })
      // Returns the changed selection
      this.$emit('input', selected.map(item => {
        return {
          id: item.id,
          name: item.name
        }
      }))
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
